import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

import { CSSProp, css } from 'styled-components';

const styles: ComponentStylesProps<string> = {
  scrollEffect: (shadowColor) => ({
    // Vertical scroll effect shadow
    backgroundImage: `
      linear-gradient(to top, white, white),
      linear-gradient(to top, white, white),
      linear-gradient(to top, ${shadowColor || 'rgba(0, 29, 108, 0.25)'}, rgba(255, 255, 255, 0)),
      linear-gradient(to bottom,${shadowColor || 'rgba(0, 29, 108, 0.25)'}, rgba(255, 255, 255, 0))`,
    backgroundPosition: 'bottom center, top center, bottom center, top center',
    backgroundColor: 'white',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 20px, 100% 20px, 100% 10px, 100% 10px',
    backgroundAttachment: 'local, local, scroll, scroll',
  }),
};

const createScrollEffectStyles = createUseStyles(styles);
export { createScrollEffectStyles };

export const scrollEffectStyle = (shadowColor?: string): CSSProp => css`
  background-image: linear-gradient(to top, white, white), linear-gradient(to top, white, white),
    linear-gradient(to top, ${shadowColor || 'rgba(0, 29, 108, 0.25)'}, rgb(255 255 255 / 0%)),
    linear-gradient(to bottom, ${shadowColor || 'rgba(0, 29, 108, 0.25)'}, rgb(255 255 255 / 0%));
  background-position: bottom center, top center, bottom center, top center;
  background-color: white;
  background-repeat: no-repeat;
  background-size: 100% 20px, 100% 20px, 100% 10px, 100% 10px;
  background-attachment: local, local, scroll, scroll;
`;
